'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cwUi = require('cw-ui');

var _googleLibphonenumber = require('google-libphonenumber');

var _AutomationName = require('../../../services/AutomationName');

var _AutomationName2 = _interopRequireDefault(_AutomationName);

var _CountryCodeLookup = require('../../../managewidgets/components/phonenumberfield/CountryCodeLookup');

var _CountryCodeLookup2 = _interopRequireDefault(_CountryCodeLookup);

var _ClickTracker = require('../../../services/ClickTracker');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var plusCheck = new RegExp('^\\+');

/**
 * Textfield that applies a mask to the value as indicated by the countryName prop.
 * Stips out all characters in the value except numeric and plus symbols.
 */

var PhoneNumberField = function (_React$Component) {
  (0, _inherits3.default)(PhoneNumberField, _React$Component);

  function PhoneNumberField() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PhoneNumberField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PhoneNumberField.__proto__ || (0, _getPrototypeOf2.default)(PhoneNumberField)).call.apply(_ref, [this].concat(args))), _this), _this.stripMask = function (value) {

      if (!value) {
        return value;
      }

      return value.replace(/[^\d\+-]/g, '');
    }, _this.getAutomationName = function () {
      return _AutomationName2.default.get('phn', _this.props.automationName);
    }, _this.handleChange = function (value) {
      (0, _ClickTracker.addEditTrack)(_this.getAutomationName());
      _this.props.onChange(_this.stripMask(value));
    }, _this.maskNumber = function (value, countryName) {
      var instance = _googleLibphonenumber.PhoneNumberUtil.getInstance();

      var number = null;

      try {
        number = instance.parse(value, (0, _CountryCodeLookup2.default)(countryName));
      } catch (error) {}
      // due to this library using exceptions for non exceptional circumstances we are forced
      // to eat this error


      // if we have a number format
      if (number && instance.isPossibleNumber(number)) {
        return instance.format(number, _googleLibphonenumber.PhoneNumberFormat.NATIONAL);
      } else {
        // otherwise just set to the raw value
        return value;
      }
    }, _this.applyPhoneMask = function (value) {
      // if no value or no countrName
      if (!value || !_this.props.countryName || _this.props.countryName === '') {
        return value;
        // if number starts with + just set raw value
      } else if (plusCheck.test(value)) {
        return value;
        // attempt to mask new value
      } else {
        return _this.maskNumber(value, _this.props.countryName);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PhoneNumberField, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_cwUi.CwTextField, (0, _assign2.default)({}, this.props, {
        cwId: this.getAutomationName(),
        onChange: this.props.onChange ? this.handleChange : undefined,
        value: this.applyPhoneMask(this.props.value)
      }));
    }
  }]);
  return PhoneNumberField;
}(_react2.default.Component);

;

PhoneNumberField.propTypes = (0, _assign2.default)({
  /**
   * Country Name used to look up the country code.
   */
  countryName: _propTypes2.default.string,
  /**
   * Element id used as selection and search for automation testing
   */
  automationName: _propTypes2.default.string
}, _cwUi.CwTextField.propTypes);

exports.default = PhoneNumberField;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/managewidgets/components/phonenumberfield/PhoneNumberField.js
// module id = 790
// module chunks = 10